import { useState } from "react";
import { useContract } from "./useContract";
import { AddContractIProps } from "../model/schema";

interface MutateOptions {
  onSuccess?: (data: any) => void;
  onError?: (error: any) => void;
}

export const useAddContract = () => {
  const { addContract } = useContract();
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isSuccess, setIsSuccess] = useState(false);

  const mutate = async (data: AddContractIProps, options?: MutateOptions) => {
    setIsLoading(true);
    setError(null);
    setIsSuccess(false);

    try {
      const result = await addContract(data);
      if (result.data) {
        setData(result.data);
        options?.onSuccess?.(result.data);
      } else {
        setError("Не удалось сохранить договор");
        options?.onError?.("Не удалось сохранить договор");
      }
    } catch (error) {
      options?.onError?.("Не удалось сохранить договор");
      setError("Не удалось сохранить договор");
    } finally {
      setIsLoading(false);
    }
  };

  return { mutate, isLoading, error, isSuccess, data };
};
